import { z } from 'zod';
import { parsePhoneNumberFromString, getCountryCallingCode } from 'libphonenumber-js';

// src/phone/index.ts
var PHONE_MAX_LENGTH = 50;
function phoneErrorMessage(reason) {
  return reason === "too_long" ? `Phone number must be ${PHONE_MAX_LENGTH} characters or fewer` : "Enter a valid phone number";
}
function normalizePhone(input, defaultCountry = "US") {
  const trimmed = (input ?? "").trim();
  if (trimmed === "") return { ok: true, e164: "" };
  if (trimmed.length > PHONE_MAX_LENGTH) return { ok: false, reason: "too_long" };
  const parsed = parsePhoneNumberFromString(trimmed, defaultCountry);
  if (!parsed || !parsed.isValid()) return { ok: false, reason: "invalid" };
  const e164 = parsed.format("E.164");
  return parsed.ext ? { ok: true, e164, extension: parsed.ext } : { ok: true, e164 };
}
var E164_SHAPE = /^\+[1-9]\d{6,14}$/;
function isStoredPhone(value) {
  return value === "" || typeof value === "string" && E164_SHAPE.test(value);
}
function isValidPhone(input, defaultCountry = "US") {
  const result = normalizePhone(input, defaultCountry);
  return result.ok && result.e164 !== "";
}
function formatPhoneForDisplay(value, defaultCountry = "US") {
  const trimmed = (value ?? "").trim();
  if (trimmed === "") return "";
  const parsed = parsePhoneNumberFromString(trimmed, defaultCountry);
  if (!parsed || !parsed.isValid()) return "";
  return parsed.countryCallingCode === getCountryCallingCode(defaultCountry) ? parsed.formatNational() : parsed.formatInternational();
}
function hasPhoneExtension(value, defaultCountry = "US") {
  const trimmed = (value ?? "").trim();
  if (trimmed === "") return false;
  return Boolean(parsePhoneNumberFromString(trimmed, defaultCountry)?.ext);
}
function phoneForDisplay(value, defaultCountry = "US") {
  const trimmed = (value ?? "").trim();
  if (trimmed === "") return { label: "", telHref: null };
  const parsed = parsePhoneNumberFromString(trimmed, defaultCountry);
  if (!parsed || !parsed.isValid()) return { label: trimmed, telHref: null };
  return { label: formatPhoneForDisplay(trimmed, defaultCountry), telHref: parsed.getURI() };
}
var phoneInputSchema = z.string().trim().max(PHONE_MAX_LENGTH, phoneErrorMessage("too_long"));

export { PHONE_MAX_LENGTH, formatPhoneForDisplay, hasPhoneExtension, isStoredPhone, isValidPhone, normalizePhone, phoneErrorMessage, phoneForDisplay, phoneInputSchema };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map